import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './configureStore';
import { initSentry, Sentry } from './sentry'
import LoadingState from './components/LoadingState'
import { startInitialLoading } from './components/initialLoading'

import { installNumericInputScrollGuard } from './helpers/numericInputScrollGuard'

installNumericInputScrollGuard()

const App = React.lazy(() => import('./App'))
const RenderPage = React.lazy(() => import('./features/cim-builder/RenderPage'))

initSentry()

startInitialLoading()
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<LoadingState fullScreen />}>
      <Sentry.ErrorBoundary fallback={<RootErrorFallback />}>
        <React.Suspense fallback={<LoadingState fullScreen />}>
          {window.location.pathname === '/cim-render' ? <RenderPage /> : <App />}
        </React.Suspense>
      </Sentry.ErrorBoundary>
    </PersistGate>
  </Provider>
);

function RootErrorFallback() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Something went wrong.</h1>
      <p>Refresh the page to try again.</p>
    </div>
  )
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
